import EditBase from "../EditBase"

class EditPolygon extends EditBase {

    constructor(options) {
        super(options);
    }

    initProperty(bool) {
        var $this = this;
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            return new $this.Cesium.PolygonHierarchy($this.plot.attrPlot["edit_positions"]);
        }, bool);
        this.plot.polygon.hierarchy = hierarchyProperty;
    }
}

export default EditPolygon;